//Generated File 
export default class BSCEntities{
	static readonly APICredentials = `APICredentials`;
	static readonly AccountingCalendar = `AccountingCalendar`;
	static readonly AccountingSideConfig = `AccountingSideConfig`;
	static readonly AccountsBag = `AccountsBag`;
	static readonly AdditionalCost = `AdditionalCost`;
	static readonly AddressRegion = `AddressRegion`;
	static readonly ApprovalDefinition = `ApprovalDefinition`;
	static readonly ApprovalReason = `ApprovalReason`;
	static readonly BICrossFilter = `BICrossFilter`;
	static readonly BIPeriodComparisonConfig = `BIPeriodComparisonConfig`;
	static readonly BudgetScenario = `BudgetScenario`;
	static readonly BulkEditConfig = `BulkEditConfig`;
	static readonly BulkMessage = `BulkMessage`;
	static readonly Car = `Car`;
	static readonly CarBrand = `CarBrand`;
	static readonly CarModel = `CarModel`;
	static readonly ConfigEntry = `ConfigEntry`;
	static readonly ConfigGroup = `ConfigGroup`;
	static readonly Contact = `Contact`;
	static readonly CriteriaBasedValidator = `CriteriaBasedValidator`;
	static readonly CriteriaDefinition = `CriteriaDefinition`;
	static readonly Currency = `Currency`;
	static readonly CustomListView = `CustomListView`;
	static readonly CustomReportMenu = `CustomReportMenu`;
	static readonly Customer = `Customer`;
	static readonly CustomerCategory = `CustomerCategory`;
	static readonly CustomerClass = `CustomerClass`;
	static readonly CustomerClass1 = `CustomerClass1`;
	static readonly CustomerClass2 = `CustomerClass2`;
	static readonly CustomerClass3 = `CustomerClass3`;
	static readonly CustomerClass4 = `CustomerClass4`;
	static readonly CustomerClass5 = `CustomerClass5`;
	static readonly DLVDeliveryArea = `DLVDeliveryArea`;
	static readonly DLVDeliveryConfig = `DLVDeliveryConfig`;
	static readonly DLVDeliveryDocument = `DLVDeliveryDocument`;
	static readonly DLVDeliveryPlan = `DLVDeliveryPlan`;
	static readonly DLVDeliveryReturn = `DLVDeliveryReturn`;
	static readonly DLVDriverCarAreaAssignment = `DLVDriverCarAreaAssignment`;
	static readonly DMSCompressedFileToDocs = `DMSCompressedFileToDocs`;
	static readonly DMSDocMovement = `DMSDocMovement`;
	static readonly DMSDocument = `DMSDocument`;
	static readonly DMSFolder = `DMSFolder`;
	static readonly DMSFolderMovement = `DMSFolderMovement`;
	static readonly DMSLocation = `DMSLocation`;
	static readonly DMSTopic = `DMSTopic`;
	static readonly DashBoard = `DashBoard`;
	static readonly DashBoardGroup = `DashBoardGroup`;
	static readonly DashBoardWidget = `DashBoardWidget`;
	static readonly DashBoardWidgetWizard = `DashBoardWidgetWizard`;
	static readonly DataSource = `DataSource`;
	static readonly DatabaseCleaner = `DatabaseCleaner`;
	static readonly DatesOverrider = `DatesOverrider`;
	static readonly DefaultValuesTemplate = `DefaultValuesTemplate`;
	static readonly Delegation = `Delegation`;
	static readonly DeliveryCar = `DeliveryCar`;
	static readonly DepartmentSection = `DepartmentSection`;
	static readonly DetailedRemark = `DetailedRemark`;
	static readonly DetailedRevisionConfig = `DetailedRevisionConfig`;
	static readonly DiscountCoupon = `DiscountCoupon`;
	static readonly DiscountCouponBook = `DiscountCouponBook`;
	static readonly DiscountCouponType = `DiscountCouponType`;
	static readonly DocCategory = `DocCategory`;
	static readonly DocumentCancelDocument = `DocumentCancelDocument`;
	static readonly EInvoiceNotificationReceiver = `EInvoiceNotificationReceiver`;
	static readonly EmpWorkPlace = `EmpWorkPlace`;
	static readonly Employee = `Employee`;
	static readonly EmployeeAgenda = `EmployeeAgenda`;
	static readonly EmployeeDepartment = `EmployeeDepartment`;
	static readonly EmployeeGroup = `EmployeeGroup`;
	static readonly EntityFlow = `EntityFlow`;
	static readonly EntityHelp = `EntityHelp`;
	static readonly EntityTypeList = `EntityTypeList`;
	static readonly ErrorMessage = `ErrorMessage`;
	static readonly ExchangeRate = `ExchangeRate`;
	static readonly FeatureSet = `FeatureSet`;
	static readonly FieldFiltering = `FieldFiltering`;
	static readonly FilesExportMenu = `FilesExportMenu`;
	static readonly FiscalPeriod = `FiscalPeriod`;
	static readonly FiscalYear = `FiscalYear`;
	static readonly FiscalYearStatusUpdate = `FiscalYearStatusUpdate`;
	static readonly FormDoc1 = `FormDoc1`;
	static readonly FormDoc10 = `FormDoc10`;
	static readonly FormDoc11 = `FormDoc11`;
	static readonly FormDoc12 = `FormDoc12`;
	static readonly FormDoc13 = `FormDoc13`;
	static readonly FormDoc14 = `FormDoc14`;
	static readonly FormDoc15 = `FormDoc15`;
	static readonly FormDoc16 = `FormDoc16`;
	static readonly FormDoc2 = `FormDoc2`;
	static readonly FormDoc3 = `FormDoc3`;
	static readonly FormDoc4 = `FormDoc4`;
	static readonly FormDoc5 = `FormDoc5`;
	static readonly FormDoc6 = `FormDoc6`;
	static readonly FormDoc7 = `FormDoc7`;
	static readonly FormDoc8 = `FormDoc8`;
	static readonly FormDoc9 = `FormDoc9`;
	static readonly FreezeProcessingDoc = `FreezeProcessingDoc`;
	static readonly FreightLine = `FreightLine`;
	static readonly GUIPostActions = `GUIPostActions`;
	static readonly GUITheme = `GUITheme`;
	static readonly GeneralAnnouncement = `GeneralAnnouncement`;
	static readonly GenericReferenceOverrider = `GenericReferenceOverrider`;
	static readonly GoPayAccount = `GoPayAccount`;
	static readonly GoPayConfiguration = `GoPayConfiguration`;
	static readonly HRExperience = `HRExperience`;
	static readonly HRInsurancePolicy = `HRInsurancePolicy`;
	static readonly HRSkill = `HRSkill`;
	static readonly HijriTable = `HijriTable`;
	static readonly ImplementationRepository = `ImplementationRepository`;
	static readonly JobPosition = `JobPosition`;
	static readonly KeyWordFile = `KeyWordFile`;
	static readonly KeyWordValue = `KeyWordValue`;
	static readonly KeywordTemplate = `KeywordTemplate`;
	static readonly LegalLicense = `LegalLicense`;
	static readonly LimitUserToYear = `LimitUserToYear`;
	static readonly MeetingRemark = `MeetingRemark`;
	static readonly MenuDefinition = `MenuDefinition`;
	static readonly MenuModifier = `MenuModifier`;
	static readonly MobileAppAction = `MobileAppAction`;
	static readonly MobileAppDashboard = `MobileAppDashboard`;
	static readonly MobileAppFieldsSearcherContext = `MobileAppFieldsSearcherContext`;
	static readonly MobileAppMenuDefinition = `MobileAppMenuDefinition`;
	static readonly MobileAppScreenModifier = `MobileAppScreenModifier`;
	static readonly MobileAppShortcut = `MobileAppShortcut`;
	static readonly MobileAppTranslationOverride = `MobileAppTranslationOverride`;
	static readonly MobileEntityTitleModifier = `MobileEntityTitleModifier`;
	static readonly MobileQRIntegrator = `MobileQRIntegrator`;
	static readonly ModifyCustomerInfoReq = `ModifyCustomerInfoReq`;
	static readonly ModifySupplierInfoReq = `ModifySupplierInfoReq`;
	static readonly MultiValueReportParameter = `MultiValueReportParameter`;
	static readonly Nationality = `Nationality`;
	static readonly NotificationDefinition = `NotificationDefinition`;
	static readonly OAuthFile = `OAuthFile`;
	static readonly OnlinePaymentConfig = `OnlinePaymentConfig`;
	static readonly OrganizationPosition = `OrganizationPosition`;
	static readonly PGWMethodGroup = `PGWMethodGroup`;
	static readonly PartnerShares = `PartnerShares`;
	static readonly PaymentFromPosSettings = `PaymentFromPosSettings`;
	static readonly PaymentLinksCreationDoc = `PaymentLinksCreationDoc`;
	static readonly PaymentMethod = `PaymentMethod`;
	static readonly PaymentScheduleTemplate = `PaymentScheduleTemplate`;
	static readonly PaymentTerminal = `PaymentTerminal`;
	static readonly PerformanceOptimizer = `PerformanceOptimizer`;
	static readonly PeriodicRewardPointsGrantDocument = `PeriodicRewardPointsGrantDocument`;
	static readonly PrintingFormWizard = `PrintingFormWizard`;
	static readonly PurgeConfig = `PurgeConfig`;
	static readonly QuickFilterCriteria = `QuickFilterCriteria`;
	static readonly ReceiptBook = `ReceiptBook`;
	static readonly ReceiptPaper = `ReceiptPaper`;
	static readonly RecordImportConfig = `RecordImportConfig`;
	static readonly RecordImportDoc = `RecordImportDoc`;
	static readonly RecordImportList = `RecordImportList`;
	static readonly RecuringDocument = `RecuringDocument`;
	static readonly Remark = `Remark`;
	static readonly RemarkType = `RemarkType`;
	static readonly RemarkType2 = `RemarkType2`;
	static readonly RemarkType3 = `RemarkType3`;
	static readonly RemarkType4 = `RemarkType4`;
	static readonly RemarkType5 = `RemarkType5`;
	static readonly ReplicationSite = `ReplicationSite`;
	static readonly ReportDefinition = `ReportDefinition`;
	static readonly ReportGroup = `ReportGroup`;
	static readonly ReportStyle = `ReportStyle`;
	static readonly ReportWizard = `ReportWizard`;
	static readonly RequiredFields = `RequiredFields`;
	static readonly Responsibility = `Responsibility`;
	static readonly ReverseRedeemAmountDoc = `ReverseRedeemAmountDoc`;
	static readonly RevisionDoc = `RevisionDoc`;
	static readonly RewardPointCalculatorConfig = `RewardPointCalculatorConfig`;
	static readonly RewardPointsConfig = `RewardPointsConfig`;
	static readonly RewardPointsOpening = `RewardPointsOpening`;
	static readonly RewardPointsRestriction = `RewardPointsRestriction`;
	static readonly SafeDeposite = `SafeDeposite`;
	static readonly SalesPriceClassifier1 = `SalesPriceClassifier1`;
	static readonly SalesPriceClassifier2 = `SalesPriceClassifier2`;
	static readonly SalesPriceClassifier3 = `SalesPriceClassifier3`;
	static readonly SalesPriceClassifier4 = `SalesPriceClassifier4`;
	static readonly SalesPriceClassifier5 = `SalesPriceClassifier5`;
	static readonly SalesStandardTerm = `SalesStandardTerm`;
	static readonly ScreenModifier = `ScreenModifier`;
	static readonly SecurityCapability = `SecurityCapability`;
	static readonly SecurityProfile = `SecurityProfile`;
	static readonly SecurityProfileTransfer = `SecurityProfileTransfer`;
	static readonly ShippingPort = `ShippingPort`;
	static readonly ShoppingMobAppConfig = `ShoppingMobAppConfig`;
	static readonly ShortCutsDefinition = `ShortCutsDefinition`;
	static readonly SpecialResponsible = `SpecialResponsible`;
	static readonly Sponsor = `Sponsor`;
	static readonly StandardTermExtension = `StandardTermExtension`;
	static readonly StandardTermFulfillment = `StandardTermFulfillment`;
	static readonly Subsidiary1 = `Subsidiary1`;
	static readonly Subsidiary2 = `Subsidiary2`;
	static readonly Subsidiary3 = `Subsidiary3`;
	static readonly Subsidiary4 = `Subsidiary4`;
	static readonly Subsidiary5 = `Subsidiary5`;
	static readonly SubsidiaryClass = `SubsidiaryClass`;
	static readonly Supplier = `Supplier`;
	static readonly SupplierClass = `SupplierClass`;
	static readonly TaskQueue = `TaskQueue`;
	static readonly TaskSchedule = `TaskSchedule`;
	static readonly TaxAuthoritySubmissionDoc = `TaxAuthoritySubmissionDoc`;
	static readonly TaxDiscountEffectsConfig = `TaxDiscountEffectsConfig`;
	static readonly TaxPayerConfiguration = `TaxPayerConfiguration`;
	static readonly TaxPlan = `TaxPlan`;
	static readonly TelegramBotConfiguration = `TelegramBotConfiguration`;
	static readonly TelegramMessage = `TelegramMessage`;
	static readonly ThirdParty = `ThirdParty`;
	static readonly TooltipDefinition = `TooltipDefinition`;
	static readonly TranslationOverRider = `TranslationOverRider`;
	static readonly UpdateCustomerInfo = `UpdateCustomerInfo`;
	static readonly UserAddRequest = `UserAddRequest`;
	static readonly UserFavourites = `UserFavourites`;
	static readonly UserFieldFilter = `UserFieldFilter`;
	static readonly UserFingerprint = `UserFingerprint`;
	static readonly UserMobileIdentifierDocument = `UserMobileIdentifierDocument`;
	static readonly UserTimedQuery = `UserTimedQuery`;
	static readonly UsersCounter = `UsersCounter`;
	static readonly VirtualEntity = `VirtualEntity`;
	static readonly WhatsAppMessage = `WhatsAppMessage`;
	static readonly WhatsAppMessageConfiguration = `WhatsAppMessageConfiguration`;
	static readonly WizardFile = `WizardFile`;
	static readonly WorkTask = `WorkTask`;
	static readonly WorkTaskCategory = `WorkTaskCategory`;
}
